// src/modules/components/reports/calls/CallReportsExporter.js
import { useState } from "react";
import { useDataProvider, downloadCSV } from "react-admin";
import jsonExport from 'jsonexport/dist';
import ExportProgressDialog from "./ExportProgressDialog";

const useCallReportsExporter = () => {
  const dataProvider = useDataProvider();
  const [progress, setProgress] = useState({ open: false, page: 0, totalPages: 0 });

  const exporter = async () => {
    const perPage = 100; // Increased for better performance

    // first call to get total
    const first = await dataProvider.getList("call-records", {
      pagination: { page: 1, perPage },
      sort: { field: "id", order: "ASC" },
      filter: {},
    });

    let allRecords = [...first.data];
    const totalPages = Math.ceil(first.total / perPage);

    setProgress({ open: true, page: 1, totalPages });

    for (let page = 2; page <= totalPages; page++) {
      const { data } = await dataProvider.getList("call-records", {
        pagination: { page, perPage },
        sort: { field: "id", order: "ASC" },
        filter: {},
      });
      allRecords = [...allRecords, ...data];
      setProgress({ open: true, page, totalPages });
    }

    // build CSV
    const csvData = allRecords.map(record => ({
      ID: record.id,
      Time: record.callDate,
      Caller: record.src,
      Destination: record.dst,
      Type: record.callType,
      Status: record.disposition,
      Duration: record.duration,
      Agent: record.agentId,
      Quality: record.qualityScore,
      Notes: record.notes?.length > 0 ? record.notes.length : 0,
    }));

    jsonExport(csvData, { rowDelimiter: ',' }, (err, csv) => {
      if (err) {
        console.error(err);
        return;
      }
      // Add UTF-8 BOM to fix Arabic characters in Excel
      const bom = '\uFEFF';
      downloadCSV(bom + csv, "call_records.csv");
    });

    setProgress({ open: false, page: 0, totalPages: 0 });
  };

  return {
    exporter,
    progressUI: (
      <ExportProgressDialog
        open={progress.open}
        page={progress.page}
        totalPages={progress.totalPages}
      />
    ),
  };
};

export default useCallReportsExporter;